import React from "react";

const hotels = [
  {
    name: "Burj Al-Arab",
    location: "Dubai",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "Avadh Utopia",
    location: "Surat",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "ITC Kolkata",
    location: "Kolkata",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "JW Marriott Delhi",
    location: "Delhi",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "Burj Al-Arab",
    location: "Dubai",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "Avadh Utopia",
    location: "Surat",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "ITC Kolkata",
    location: "Kolkata",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
  {
    name: "JW Marriott Delhi",
    location: "Delhi",
    price: 999,
    originalPrice: 2999,
    image:
      "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  },
];

export default function HotelGrid() {
  return (
    <div className=" space-y-8 bg-[#f4f4f4]">
      {/* Hotel Grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {hotels.map((hotel, index) => (
          <div
            key={index}
            className="flex items-center gap-4 rounded-xl bg-white p-4 shadow"
          >
            <img
              src={hotel.image}
              alt={hotel.name}
              className="h-20 w-20 rounded object-cover"
            />
            <div className="flex flex-grow flex-col justify-between">
              <h3 className="text-md font-semibold text-gray-800">
                {hotel.name}
              </h3>
              <p className="text-sm text-gray-600">{hotel.location}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold text-black">
                ₹{hotel.price}/-
              </p>
              <p className="text-sm text-gray-400 line-through">
                ₹{hotel.originalPrice}/-
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Info Box */}
      <div className="flex items-center gap-4 rounded-xl bg-white p-6 shadow">
        <div className="text-2xl text-gray-600">🔔</div>
        <p className="text-md font-medium text-gray-700">
          Since hotel rates and availability change frequently, the deal you
          viewed on <span className="font-semibold">Makku Hotels</span> might
          not always match what appears on the booking site.
        </p>
      </div>
    </div>
  );
}
